// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__h3Hnd","insightsList":"newBusinessInsightsMenu_insightsList__3nLT-","active":"newBusinessInsightsMenu_active__1ZMkL"};